import { Filter } from "../Filter/Filter";
import { Pagination } from "../Pagination/Pagination";
import { useActor, useMachine } from "@xstate/react";
import { shopMachine } from "../../xstate/shop.machine";
import { Loader } from "../Loader/Loader";
import { Showcase } from "../Showcase/Showcase";
import { useEffect } from "react";
import InfoCardModal from "./InfoCardModal";

export function ShopPage() {
	let [state, send, service] = useMachine(shopMachine);

	return (
		<>
			<Filter ShopState={service} />
			{state.matches("loading") ? (
				<Loader />
			) : (
				<>
					{/* <div className="wrapper" style={{ marginTop: "25px" }}>
						<div style={{ maxWidth: "900px" }}>
							<p>
								📅 <b>Витрина подарочных сертификатов временно недоступна.</b>
							</p>{" "}
							<p>
								В 2025 году сертификаты разобрали почти полностью. Во время
								паузы мы восполним их количество, чтобы вы могли спокойно
								выбрать нужный сертификат без спешки.
							</p>
							<p>
								<b>Напоминаем:</b> все непотраченные баллы за загруженные чеки в
								2025 году <b>автоматически перейдут на текущий год</b> — вы
								сможете использовать их уже в январе.
							</p>{" "}
							<p>
								С наступившим Новым годом!
								<br /> Пусть ваши усилия приносят ещё больше результатов и
								приятных наград.
							</p>
						</div>
					</div> */}
					{/* <InfoCardModal /> */}
					<Showcase ShopState={service} />
					{state.context.pages > 1 && (
						<Pagination
							current_page={state.context.current_page}
							pages={state.context.pages}
							send={send}
						/>
					)}
				</>
			)}
		</>
	);
}
